import { text } from '@modules/login/text';
import type { FormEvent } from 'react';
import type { LoginFormCopy } from './models';
import { text as featureText } from './text_business_logic';

export type { LoginFormCopy } from './models';

export function getLoginFormCopy(isSubmitting: boolean): LoginFormCopy {
  return featureText.loginFormCopy(isSubmitting);
}

export function getLoginErrorMessage(error: Error): string {
  return error.message.includes('Invalid password') ? text.invalidPassword : text.error;
}

export function createLoginFormSubmitHandler(onSubmit: () => void) {
  return (event: FormEvent) => {
    event.preventDefault();
    onSubmit();
  };
}
